export enum RefreshTypeEnum{
    normalRefresh = 1,
    fullRefresh = 2,  
}